<template>
  <card class="card-timeline" plain>
    <ul class="timeline" :class="{ 'timeline-simple': type === 'simple' }">
      <slot></slot>
    </ul>
  </card>
</template>
<script>
import card from "@/components/Cards/Card.vue";

export default {
  components: {
    card
  },
  name: "time-line",
  props: {
    type: {
      type: String,
      default: ""
    }
  }
};
</script>
<style></style>
